/**
 * Format a number as currency with locale support.
 *
 * @param amount - The numeric amount to format
 * @param options - Formatting options
 * @param options.currency - Currency code (default: 'IDR')
 * @param options.locale - Locale for formatting (default: 'id-ID')
 * @param options.minimumFractionDigits - Minimum decimal places (default: 0)
 * @param options.maximumFractionDigits - Maximum decimal places (default: 2)
 * @param options.removeSpaces - Whether to remove spaces from output (default: true)
 *
 * @example
 * formatCurrency(500000) // 'Rp500.000'
 * formatCurrency(500000, { currency: 'USD', locale: 'en-US' }) // '$500.00'
 * formatCurrency(1234.56, { maximumFractionDigits: 2 }) // 'Rp1.234,56'
 */
export function formatCurrency(
  amount: number,
  options: {
    currency?: string
    locale?: string
    minimumFractionDigits?: number
    maximumFractionDigits?: number
    removeSpaces?: boolean
  } = {},
): string {
  const {
    currency = 'IDR',
    locale = 'id-ID',
    minimumFractionDigits = 0,
    maximumFractionDigits = 2,
    removeSpaces = true,
  } = options

  const formatted = amount.toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  })

  return removeSpaces ? formatted.replace(/\s/g, '') : formatted
}
